import React from "react";
import EmptyPage from "../../components/EmptyPage";

const General = () => {
  return (
    <EmptyPage
      title="General Settings"
      description="Configure general application settings including preferences, defaults, notifications, and system-wide configurations."
      icon="⚙️"
    />
  );
};

export default General;
